import config from "./app.json";
import axios from "axios";

import { Context } from "./Reducers/Store";
import React, { useEffect, useContext, useState, useRef } from "react";
import Layout from "./Pages/Layout";
import { LayoutEmpty } from "./Pages/LayoutEmpty";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import RequireAuth from "./RequireAuth";
import AlertComponent from "./Components/AlertComponent";

import NotFound from "./Pages/NotFound";

// Logged
import Home from "./Pages/Logged/Home";

// Not logged
import Login from "./Pages/NotLogged/Login";
import Register from "./Pages/NotLogged/Register";
import CodeVerification from "./Pages/Logged/CodeVerification";
import Account from "./Pages/Logged/Account";
import Branding from "./Pages/Logged/Branding";
import SelectPlan from "./Components/SelectPlan";
import EventDetail from "./Pages/Logged/EventDetail";
import ListingChannels from "./Pages/Logged/ListingChannels";
import ListingEvents from "./Pages/Logged/ListingEvents";
import ListingInputs from "./Pages/Logged/ListingInputs";
import ListingUsers from "./Pages/Logged/ListingUsers";

import CreateChannel from "./Pages/Logged/CreateChannel";
import UserDetail from "./Pages/Logged/UserDetail";

import RecoverPassword from "./Pages/NotLogged/RecoverPassword";
import RecoverPasswordCode from "./Pages/NotLogged/RecoverPasswordCode";
import RecoverPasswordConfirmation from "./Pages/NotLogged/RecoverPasswordConfirmation";
import AddOrEditInput from "./Components/AddAndEditChannel/AddOrEditInput";

import OnDemandSettings from "./Pages/Logged/OnDemandSettings";
import VideoArchive from "./Pages/Logged/VideoArchive";
import VideoArchiveEdit from "./Pages/Logged/VideoArchiveEdit";
import ListingSeries from "./Pages/Logged/ListingSeries";
import SeriesDetail from "./Pages/Logged/SeriesDetail";

function App() {
  const [state, dispatch] = useContext(Context);
  const [title, setTitle] = useState(null);
  const channelStatusTimer = useRef(null);
  const channelThumbnailTimer = useRef(null);

  useEffect(() => {
    console.log(state.channelStatus);
  }, [state.channelStatus]);

  useEffect(() => {
    if (channelStatusTimer.current)
      clearInterval(channelStatusTimer.current);

    if (channelThumbnailTimer.current)
      clearInterval(channelThumbnailTimer.current);

    if (state.isLogged) {
      fetchStatus();
      channelStatusTimer.current = setInterval(fetchStatus, 30000);

      //fetchChannelData();
      //channelStatusTimer.current = setInterval(fetchChannelData, 5000);
    }

    return () => {
      if (channelStatusTimer.current)
        clearInterval(channelStatusTimer.current);

      if (channelThumbnailTimer.current)
        clearInterval(channelThumbnailTimer.current);
    }
  }, [state.isLogged]);

  const fetchStatus = async () => {
    if (window._channelsIds != null && window._channelsIds.length > 0) {
      let channelStatus = {};
      for (let index = 0; index < window._channelsIds.length; index++) {
        const element = window._channelsIds[index];

        if (window._wait && window._wait[element]) {
          channelStatus[element] = window._wait[element];
          continue;
        }

        await await axios.post(config.API + "/api/channel/getChannelState", {
          id: element
        }).then((res) => {
          if (res.status === 200 && res.data) {
            if (window._wait && window._wait[element])
              channelStatus[element] = window._wait[element];
            else
              channelStatus[element] = res.data;
          }
        }).catch(function (error) {
          channelStatus[element] = "ERROR";
        });
      }
      dispatch({ type: "SET_CHANNEL_STATUS", payload: channelStatus });
    }
    else
      setTimeout(fetchStatus, 500);
  }

  useEffect(() => {
    if (!state.ready) {
      var auth = localStorage.getItem("auth");
      if (auth != null) {
        let configRequest = { headers: { Authorization: "Bearer " + auth } };
        axios.post(config.API + "/api/user/getProfile", null, configRequest).then((res) => {
          axios.post(config.API + "/api/church/getBasicChurch", null, configRequest).then((resC) => {
            dispatch([
              { type: "SET_CHURCH", payload: resC.data },
              { type: "SET_LOGGED", payload: { jwt: auth, profile: res.data } },
              { type: "SET_READY", payload: true }
            ]);
          }).catch(function (error) {
            dispatch({ type: "SET_READY", payload: true });
            return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
          });
        }).catch(function (error) {
          dispatch({ type: "SET_READY", payload: true });
          return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
        });
      }
      else
        dispatch({ type: "SET_READY", payload: true });
    }
  }, [state.ready]);

  return state.ready ? (
    <BrowserRouter basename="/">
      <Routes>
        <Route element={<LayoutEmpty />}>
          {!state.isLogged && <>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/recoverpassword" element={<RecoverPassword />} />
            <Route path="/recoverPasswordCode" element={<RecoverPasswordCode />} />
            <Route path="/recoverpasswordconfirmation" element={<RecoverPasswordConfirmation />} />
          </>}
          {(state.isLogged && !state.profile?.emailValidated) && <Route path="/codeVerification" element={<RequireAuth><CodeVerification /></RequireAuth>} />}
          {(state.isLogged && state.profile?.emailValidated && !state.hasBranding) && <Route path="/branding" element={<RequireAuth><Branding /></RequireAuth>} />}
          {(state.isLogged && state.profile?.emailValidated && state.hasBranding && (!state.hasPlan || !state.church?.active)) && <Route path="/selectPlan" element={<RequireAuth><SelectPlan /></RequireAuth>} />}
        </Route>

        <Route element={<Layout />}>
          <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
          <Route path="/account" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><Account /></RequireAuth>} />
          <Route path="/ondemandsettings" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><OnDemandSettings /></RequireAuth>} />
          <Route path="/newEvent" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><EventDetail /></RequireAuth>} />
          <Route path="/manageEvent/:id" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><EventDetail /></RequireAuth>} />
          <Route path="/manageChannel/:id" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><CreateChannel /></RequireAuth>} />
          <Route path="/listingChannels" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><ListingChannels /></RequireAuth>} />
          <Route path="/listingEvents" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN', 'ROLE_CHURCH_PRODUCER']}><ListingEvents /></RequireAuth>} />
          <Route path="/listingInputs" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><ListingInputs /></RequireAuth>} />
          <Route path="/newInput" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><AddOrEditInput newInputPage={true} /></RequireAuth>} />
          <Route path="/manageInput/:id" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><AddOrEditInput newInputPage={true} /></RequireAuth>} />
          <Route path="/users" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><ListingUsers /></RequireAuth>} />
          <Route path="/addNewChannel" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><CreateChannel /></RequireAuth>} />
          <Route path="/users/new" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><UserDetail /></RequireAuth>} />
          <Route path="/users/edit/:id" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><UserDetail /></RequireAuth>} />
          <Route path="/videoArchive" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN', 'ROLE_CHURCH_MEDIA_MANAGER']}><VideoArchive /></RequireAuth>} />
          <Route path="/videoArchive/edit/:id" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN', 'ROLE_CHURCH_MEDIA_MANAGER']}><VideoArchiveEdit /></RequireAuth>} />
          <Route path="/videoArchive/series" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN', 'ROLE_CHURCH_MEDIA_MANAGER']}><ListingSeries /></RequireAuth>} />
          <Route path="/videoArchive/series/new" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><SeriesDetail /></RequireAuth>} />
          <Route path="/videoArchive/series/general" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><SeriesDetail general={true} /></RequireAuth>} />
          <Route path="/videoArchive/series/edit/:id" element={<RequireAuth roles={['ROLE_CHURCH_ADMIN']}><SeriesDetail /></RequireAuth>} />
        </Route>

        <Route path='*' element={<NotFound />} />

      </Routes>
    </BrowserRouter>
  ) : null;
}

export default App;
